import { PREFERRED_DISPLAY_LANGUAGE } from '../../constants/settings'

type Props = {
  displayLanguage: string | null
}

const footerLinks = [
  {
    href: '/wordle-japanese-4-strategy',
    ja: '日本語Wordle 4文字攻略',
    en: 'Japanese Wordle 4-character strategy',
  },
  {
    href: '/japanese-wordle',
    ja: 'Japanese Wordle入門',
    en: 'Japanese Wordle guide',
  },
  {
    href: '/japanese-learning-games',
    ja: '日本語学習ゲーム',
    en: 'Japanese Learning Games',
  },
  {
    href: '/basic-japanese-words',
    ja: '基本的な日本語単語',
    en: 'Basic Japanese Words',
  },
  {
    href: '/hiragana-words',
    ja: 'ひらがな単語',
    en: 'Hiragana Words',
  },
  {
    href: '/hiragana-quiz',
    ja: 'ひらがなクイズ',
    en: 'Hiragana Quiz',
  },
  {
    href: '/wordle-japanese-5-guide',
    ja: '日本語Wordle 5文字ガイド',
    en: 'Japanese Wordle 5-character guide',
  },
  {
    href: '/three-letter-japanese-words',
    ja: '3文字の言葉一覧',
    en: 'Three-Letter Japanese Words',
  },
  {
    href: '/four-letter-japanese-words',
    ja: '4文字の言葉一覧',
    en: 'Four-Letter Japanese Words',
  },
  {
    href: '/kotonoha-tango-strategy',
    ja: 'ことのはたんご攻略',
    en: 'Kotonoha Tango strategy',
  },
  {
    href: '/five-letter-japanese-words',
    ja: '5文字の言葉一覧',
    en: 'Five-Letter Japanese Words',
  },
  {
    href: '/six-letter-japanese-words',
    ja: '6文字の言葉一覧',
    en: 'Six-Letter Japanese Words',
  },
  {
    href: '/shiritori-word-list',
    ja: 'しりとり単語一覧',
    en: 'Japanese Shiritori Word List',
  },
  { href: '/about', ja: '私たちについて', en: 'About Us' },
  { href: '/privacy-policy', ja: 'プライバシーポリシー', en: 'Privacy Policy' },
  { href: '/terms-of-service', ja: '利用規約', en: 'Terms of Service' },
]

export const Footer: React.FC<Props> = ({ displayLanguage }) => {
  const isJapanese = displayLanguage === PREFERRED_DISPLAY_LANGUAGE
  const text = isJapanese
    ? {
        description:
          '日本語学習者向けの無料オンライン単語推理ゲーム。毎日新しい単語で楽しく学習。',
        links: 'リンク',
        contact: 'お問い合わせ',
        copyright:
          '© 2026 言葉で遊ぼう - Kotobade Asobou. All rights reserved.',
        launchDate: 'リリース日：2026年1月18日',
      }
    : {
        description:
          'A free daily Japanese word puzzle for learners who want short, repeatable vocabulary practice.',
        links: 'Links',
        contact: 'Contact',
        copyright: '© 2026 Kotobade Asobou. All rights reserved.',
        launchDate: 'Launch date: January 18, 2026',
      }

  return (
    <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 py-8 px-4 mt-12">
      <div className="max-w-4xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6">
          <div>
            <h3 className="font-bold text-gray-900 dark:text-white mb-3">
              言葉で遊ぼう
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              {text.description}
            </p>
          </div>

          <div>
            <h3 className="font-bold text-gray-900 dark:text-white mb-3">
              {text.links}
            </h3>
            <ul className="space-y-2 text-sm">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-gray-600 dark:text-gray-400 hover:text-green-600 dark:hover:text-green-400 transition-colors"
                  >
                    {isJapanese ? link.ja : link.en}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-gray-900 dark:text-white mb-3">
              {text.contact}
            </h3>
            <ul className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
              <li>
                <a
                  href="mailto:support@kotobade-asobou.blog"
                  className="hover:text-green-600 dark:hover:text-green-400 transition-colors"
                >
                  support@kotobade-asobou.blog
                </a>
              </li>
              <li>
                <a
                  href="https://kotobade-asobou.blog"
                  className="hover:text-green-600 dark:hover:text-green-400 transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  kotobade-asobou.blog
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 dark:border-gray-700 pt-6 text-center">
          <p className="text-sm text-gray-600 dark:text-gray-400">
            {text.copyright}
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-500 mt-2">
            {text.launchDate}
          </p>
        </div>
      </div>
    </footer>
  )
}
